export default {
	Yes: 'Yes',
	No: 'No',
	OK: 'OK',
	Cancel: 'Cancel',
	Prev: 'Previous',
	Next: 'Next',
	Start: 'Start',
	Finish: 'Finish',
	Reset: 'Reset',
	Undo: 'Undo',
	Add: 'Add',
	Save: 'Save',
	Create: 'Create',
	Update: 'Update',
	Delete: 'Delete',
	Dismiss: 'Dismiss',
	Retry: 'Retry',
	Loading: 'Loading…',
	Processing: 'Processing…',
	Error: {
		ReactError: {
			Title: 'Something is definitely gone wrong',
			Description: 'Contact developer team for an assistance'
		},
		NotFound: {
			Title: 'Whoops… There is no page like that!',
			Description: 'The page you are looking for does not exist. We share your pain.',
		}
	}
};
